var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowRightEmph(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "arrow-right-emph"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.33717 3.50371C9.70329 3.1376 10.2969 3.1376 10.663 3.50371L16.4963 9.33705C16.8624 9.70316 16.8624 10.2968 16.4963 10.6629L10.663 16.4962C10.2969 16.8623 9.70329 16.8623 9.33717 16.4962C8.97105 16.1301 8.97105 15.5365 9.33717 15.1704L13.5701 10.9375H4.16675C3.64898 10.9375 3.22925 10.5177 3.22925 9.99996C3.22925 9.48219 3.64898 9.06246 4.16675 9.06246H13.5701L9.33717 4.82954C8.97105 4.46342 8.97105 3.86983 9.33717 3.50371Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRightEmph);
export default __webpack_public_path__ + "static/media/arrow-right-emph.6e90e3fa.svg";
export { ForwardRef as ReactComponent };